(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false); /* RK: Dawn's search modal no longer exists */
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-configurator"] && !Shopify.designMode) return;
  try {
    
/* The app block ships its iframe with loading="lazy", which holds the request
   back until layout settles even though the frame is the page. Flipping the
   attribute to eager starts the fetch immediately (the spec treats lazy -> eager
   as a trigger). The branded wait is then cleared on the frame's own load. */
(function () {
  function wire(mount) {
    if (mount.dataset.rkCfgFrame) return;
    var frame = mount.querySelector('iframe');
    if (!frame) return;
    mount.dataset.rkCfgFrame = '1';
    if (frame.getAttribute('loading') === 'lazy') frame.setAttribute('loading', 'eager');

    var veil = mount.querySelector('[data-rk-cfg-loading]');
    if (!veil) return;
    var cleared = false;
    function clear() {
      if (cleared) return;
      cleared = true;
      veil.classList.add('is-done');
      setTimeout(function () { veil.hidden = true; }, 450);
    }
    /* The app is a single-page app on another origin: measured live, it paints
       its first screen at ~8.5s while its load event is late and sometimes
       never fires at all. So the wait is capped on a timer and the load event
       only ever ends it EARLY - and never before 4s, or a load that fires
       before the app has painted would hand the visitor a blank frame. */
    var started = Date.now();
    frame.addEventListener('load', function () {
      setTimeout(clear, Math.max(0, 4000 - (Date.now() - started)));
    });
    setTimeout(clear, 9000);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.rk-cfg__mount'), wire);
  }
  scan();
  /* The app block can be injected after this script runs, and the theme editor
     re-renders the section on every setting change. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  document.addEventListener('shopify:section:load', scan);
})();

/* Phone: when the builder frame first comes into view, align it under the
   header once so the whole configurator (its pinned 3D viewer + its own
   scrolling options) fills the screen. Without this the visitor scrolls the
   page half-way into the frame and the viewer sits cut off above the fold. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var mounts = document.querySelectorAll('.rk-cfg__mount');
  Array.prototype.forEach.call(mounts, function (mount) {
    /* Builder-only pages do not scroll at all, so there is nothing to align. */
    if (mount.closest('.rk-cfg--solo')) return;
    if (mount.dataset.rkCfgReady) return;
    mount.dataset.rkCfgReady = '1';
    var frame = mount.querySelector('iframe');
    if (!frame) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* "enough of it on screen" = half the viewport, not half the frame,
           which is taller than any phone screen */
        if (done || !mq.matches || e.intersectionRect.height < window.innerHeight * 0.45) return;
        done = true;
        io.disconnect();
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rk-header-h')) || 64;
        var top = frame.getBoundingClientRect().top + window.pageYOffset - header;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }, { threshold: [0.1, 0.25, 0.4, 0.55, 0.7, 0.85, 1] });
    io.observe(frame);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-hj-landing"] && !Shopify.designMode) return;
  try {
    
/* Dot nav for the featured card carousel: one dot per scroll page; hidden when 1 page. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-rk-hjl-track]');
    var dotsWrap = root.querySelector('[data-rk-hjl-dots]');
    if (!track || !dotsWrap) return;

    function pages() {
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }
    function build() {
      dotsWrap.innerHTML = '';
      var n = pages();
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rk-hjl__dot';
        b.setAttribute('data-page', String(i));
        b.setAttribute('aria-label', (dotsWrap.getAttribute('data-label') || 'Slide') + ' ' + (i + 1));
        b.addEventListener('click', function (e) {
          var p = Number(e.currentTarget.getAttribute('data-page'));
          var dir = document.documentElement.dir === 'rtl' ? -1 : 1;
          track.scrollTo({ left: dir * p * track.clientWidth, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      }
      mark();
    }
    function mark() {
      var dots = dotsWrap.querySelectorAll('.rk-hjl__dot');
      if (!dots.length) return;
      var p = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === p); });
    }
    var tScroll, tResize;
    track.addEventListener('scroll', function () { clearTimeout(tScroll); tScroll = setTimeout(mark, 80); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(tResize); tResize = setTimeout(build, 150); }, { passive: true });
    build();
  }
  document.querySelectorAll('[data-rk-hjl]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-rk-hjl]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
